/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OverviewSubItemResource } from './overviewSubItemResource';


export interface OverviewItemResource { 
    id: number;
    name: string;
    total: number;
    isInvoiceAvailable: boolean;
    subItems: Array<OverviewSubItemResource>;
}

